
import InputFieldMixin from '~/components/Inputs/_InputFieldMixin';
import { PropType, defineComponent } from 'vue';

export default defineComponent({
  name: 'TextInput',

  mixins: [InputFieldMixin],

  props: {
    rules: { type: Array as PropType<Array<() => boolean | string>>, default: () => [] },
  },

  data: () => ({
    defaultDataTestAttr: 'text',
  }),

  computed: {
    mergedRules() {
      return [this.isRequired, ...this.rules];
    },
  },
});
